export default __webpack_public_path__ + "static/media/star.d1305c93.svg";